import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { ballwinMOConfig } from "./data";

export default function BallwinMOPage() {
  return <CityPageTemplate config={ballwinMOConfig} />;
}